import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { DropdownComponent } from '../../eqform';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormGroup, Validators } from '@angular/forms';
import { EqValidator } from '../../interfaces';

@Component({
  selector: 'eq-cnf-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    DropdownComponent
  ],
  templateUrl: './season-confirmation-dialog.component.html',
  styleUrl: './season-confirmation-dialog.component.scss',
})
export class SeasonConfirmationDialogComponent {
  form: any = new FormGroup({});
  seasionOptions: { label: string, value: string }[] = [];

  seasonValidator: EqValidator[] = [
    {
      validators: Validators.required,
      error: "required",
      message: "Please select season to continue"
    }
  ]
  
  @Output() selectedSeasonEmit: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    public dialogRef: MatDialogRef<SeasonConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.seasionOptions = this.data?.seasonList
    ?.map((season: any) => ({
      label: season?.season?.name,
      value: season?._id
    }));
  }

  next() {
    this.selectedSeasonEmit.emit(this.form.value);
  }
}
